import "./Brands.module.css";
import Header from "@/reusable_sections/Header";
import Brands from "./sections/Brands";
import Expertise from "./sections/Expertise";
import BrandService from "./sections/BrandService";
import Footer from "@/reusable_sections/Footer";
export default function BrandsPage() {
  return <div>
      <Header />
      <Brands />
      <Expertise />
      <BrandService />
      <Footer />
    </div>;
}